import styled from 'styled-components';
import { Modal } from '../../../../../../lib/components/Modal/Modal';

export const StyledDeleteUserModal = styled(Modal)``;
